<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/frontusers'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom>
          <img [src]="'assets/images/user.svg'">
        </div>
        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            {{'frontUser.newUser' | translate}}
          </div>
          <div class="subtitle secondary-text">
            <span>{{'frontUser.new_user_detail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <button mat-raised-button
        class="save-product-button mat-white-bg mt-16 mt-sm-0"
        [disabled]="formGroup && formGroup.invalid" (click)="addUser()">
        <span>{{'main.add' | translate}}</span>
      </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg" >

      <!-- CONTENT -->
      <div class="content" fusePerfectScrollbar>
        <div class="content-block">

          <cropper [avatar]="''" [page]="'fr-user'" (sendImg)="setImg($event)"></cropper>

        </div>
        <div class="content-block">
          <div>
            <form [formGroup]="formGroup" class="canton-form">
              <mat-form-field appearance="fill" class="width-100">
                <mat-label>{{ 'user.role' | translate }}</mat-label>
                <mat-select formControlName="frontRoleId" required>
                  @for (role of roles; track role.value) {
                    <mat-option [value]="role.value">
                      {{role.label | translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (formGroup.get('firstName')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.firstName' | translate }}</mat-label>
                  <input formControlName="firstName" matInput required>
                </mat-form-field>
              }
              @if (formGroup.get('lastName')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.lastName' | translate }}</mat-label>
                  <input formControlName="lastName" matInput required>
                </mat-form-field>
              }
              @if (formGroup.get('nickName')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.nickName' | translate }}</mat-label>
                  <input formControlName="nickName" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('email')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.email' | translate }}</mat-label>
                  <input formControlName="email" matInput>
                  @if (formGroup.get('email')?.hasError('checkEmailOnServer')) {
                    <mat-error>
                      {{'checkEmailOnServer' | translate}}
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (formGroup.get('loginType')?.enabled && showLoginType && +platformId === 6) {
                <mat-radio-group formControlName="loginType" class="login-type"
                  >
                  <mat-label>{{ 'frontUser.loginType' | translate }}</mat-label>
                  <mat-radio-button value="email">{{'frontUser.loginByEmail' | translate}}</mat-radio-button>
                  <mat-radio-button value="mobile">{{'frontUser.loginByMobile' | translate}}</mat-radio-button>
                  @if (+formGroup.get('frontRoleId').value === 1) {
                    <mat-radio-button value="parent">{{'frontUser.loginByParent' | translate}}</mat-radio-button>
                  }
                </mat-radio-group>
              }
              @if (isOrganizer && +platformId === 6 && !!formGroup.get('frontRoleId').value) {
                <div>
                  <mat-checkbox class="width-100" [(ngModel)]="noOrganization" (ngModelChange)="checkNoOrganization($event)"
                  [ngModelOptions]="{standalone: true}">{{'frontUser.noOrganization' | translate}}</mat-checkbox>
                </div>
              }
              @if (formGroup.get('countryId')?.enabled && !noOrganization) {
                <mat-form-field appearance="fill" class="width-50"
                  >
                  <mat-label>{{ 'user.country' | translate }}</mat-label>
                  <mat-select formControlName="countryId" required>
                    @for (country of countries; track country.id) {
                      <mat-option [value]="country.id">
                        {{country.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('cityId')?.enabled && !noOrganization) {
                <mat-form-field appearance="fill" class="width-50"
                  >
                  <mat-label>{{ 'user.canton' | translate }}</mat-label>
                  <mat-select formControlName="cityId" required>
                    @for (city of cities; track city.id) {
                      <mat-option [value]="city.id">
                        {{city.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('organizationId')?.enabled && !noOrganization) {
                <mat-form-field appearance="fill" class="width-50"
                  >
                  <mat-label>{{ 'user.organization' | translate }}</mat-label>
                  <mat-select formControlName="organizationId" required>
                    @for (org of organizations; track org.id) {
                      <mat-option [value]="org.id">
                        {{org.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('tagId')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{ 'main.tag' | translate }}</mat-label>
                  <mat-select formControlName="tagId" multiple>
                    @for (tag of tags; track tag.value) {
                      <mat-option [value]="tag.value">
                        {{tag.label}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('lang')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{'user.lang' | translate}}</mat-label>
                  <mat-select formControlName="lang" required>
                    @for (lang of languages; track lang.value) {
                      <mat-option [value]="lang.value">
                        {{lang?.label}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('gender')?.enabled) {
                <mat-form-field appearance="fill" class="width-50">
                  <mat-label>{{'user.gender' | translate}}</mat-label>
                  <mat-select formControlName="gender" required>
                    @for (gen of genders; track gen.value) {
                      <mat-option [value]="gen.value">
                        {{gen?.label}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (formGroup.get('street')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.street' | translate }}</mat-label>
                  <input formControlName="street" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('number')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.number' | translate }}</mat-label>
                  <input formControlName="number" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('postcode')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.postcode' | translate }}</mat-label>
                  <input formControlName="postcode" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('cityLocation')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.city' | translate }}</mat-label>
                  <input formControlName="cityLocation" matInput>
                </mat-form-field>
              }
              @if (formGroup.get('phone')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.phone' | translate }}</mat-label>
                  <input formControlName="phone" matInput appPhoneMask>
                </mat-form-field>
              }
              @if (formGroup.get('mobile')?.enabled) {
                <mat-form-field class="width-50">
                  <mat-label>{{ 'user.mobile' | translate }}</mat-label>
                  <input formControlName="mobile" matInput appPhoneMask>
                </mat-form-field>
              }
              @if (formGroup.get('dateOfBirth')?.enabled) {
                <mat-form-field class="width-50">
                  <input matInput [matDatepicker]="picker1" placeholder="{{'user.dateOf_birth' | translate}}"
                    formControlName="dateOfBirth">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                  </mat-form-field>
                }
                @if (formGroup.get('abschlussjahr')?.enabled) {
                  <mat-form-field class="width-50">
                    <mat-label>{{ 'user.abschlussjahr' | translate }}</mat-label>
                    <input formControlName="abschlussjahr" matInput>
                  </mat-form-field>
                }
                @if (formGroup.get('dateOfBaptism')?.enabled) {
                  <mat-form-field class="width-50">
                    <input matInput [matDatepicker]="picker" placeholder="{{'user.dateOfBaptism' | translate}}"
                      formControlName="dateOfBaptism">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker disabled="false"></mat-datepicker>
                    </mat-form-field>
                  }
                  @if (formGroup.get('dateOfConfirmation')?.enabled) {
                    <mat-form-field class="width-50">
                      <input matInput [matDatepicker]="picker2" placeholder="{{'user.dateOfConfirmation' | translate}}"
                        formControlName="dateOfConfirmation">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2 disabled="false"></mat-datepicker>
                      </mat-form-field>
                    }
                    @if (formGroup.get('introdactionDate')?.enabled) {
                      <mat-form-field class="width-50">
                        <input matInput [matDatepicker]="picker3" placeholder="{{'user.introdactionDate' | translate}}"
                          formControlName="introdactionDate">
                          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                          <mat-datepicker #picker3 disabled="false"></mat-datepicker>
                        </mat-form-field>
                      }
                      @if (formGroup.get('targetGroupId')?.enabled) {
                        <mat-form-field appearance="fill" class="width-100">
                          <mat-label>{{'user.targetGroup' | translate}}</mat-label>
                          <mat-select formControlName="targetGroupId">
                            @for (tg of targetGroups; track tg.value) {
                              <mat-option [value]="tg.value">
                                {{tg?.label}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (formGroup.get('status')?.enabled) {
                        <mat-form-field appearance="fill" class="width-100">
                          <mat-label>{{'user.status-level' | translate}}</mat-label>
                          <mat-select formControlName="status" multiple>
                            @for (ls of levelStatuses; track ls.value) {
                              <mat-option [value]="ls.value">
                                {{ls?.label}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (formGroup.get('confessionId')?.enabled) {
                        <mat-form-field appearance="fill" class="width-50">
                          <mat-label>{{'user.confession' | translate}}</mat-label>
                          <mat-select formControlName="confessionId">
                            @for (cs of confessions; track cs.id) {
                              <mat-option [value]="cs.id">
                                {{cs?.name}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (formGroup.get('platformId')?.enabled && platforms.length) {
                        <mat-form-field appearance="fill" class="width-50"
                          >
                          <mat-label>{{'main.platforms' | translate}}</mat-label>
                          <mat-select formControlName="platformId">
                            @for (pl of platforms; track pl.id) {
                              <mat-option [value]="pl.id">
                                {{pl?.title}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      @if (formGroup.get('notes')?.enabled) {
                        <mat-form-field appearance="fill" class="width-100">
                          <mat-label>{{ 'user.notes' | translate }}</mat-label>
                          <textarea matInput cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="2"
                          cdkAutosizeMaxRows="5" formControlName="notes"></textarea>
                        </mat-form-field>
                      }
                      @if (formGroup.get('showFoto')?.enabled) {
                        <mat-checkbox class="width-50" formControlName="showFoto">{{'user.showFoto' | translate}}</mat-checkbox>
                      }
                      @if (formGroup.get('showChildrenName')?.enabled) {
                        <mat-checkbox class="width-50" formControlName="showChildrenName">{{'user.showChildrenName' | translate}}</mat-checkbox>
                      }
                      @if (formGroup.get('showNick')?.enabled) {
                        <mat-checkbox class="width-50" formControlName="showNick">{{'user.showNick' | translate}}</mat-checkbox>
                      }
                      @if (formGroup.get('isMember')?.enabled) {
                        <mat-checkbox class="width-50" formControlName="isMember">{{'user.isMember' | translate}}</mat-checkbox>
                      }

                    </form>
                  </div>
                  <div>

                  </div>
                </div>

              </div>
              <!-- / CONTENT -->

            </div>
            <!-- / CONTENT CARD -->

          </div>
          <!-- / CENTER -->
        </div>

